import React from "react";
import DCC from "../../PicesForPages/ConsolidationCalculator.webp";
import ConsolidationCalculatorDebt from "../CalculatorAndChart/consolidationCalculatorDebt";

function DebtConsolidationCalculator() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={DCC}
          alt="DCCImage"
          className="background-video"
        />
        <div className="purchasetopBox">
          {/* The existing Purchase span */}
          <span>Debit Consolidation</span>
        </div>
      </div>
      <ConsolidationCalculatorDebt />
    </div>
  );
}

export default DebtConsolidationCalculator;
